import React, { useCallback, useState } from 'react';
import { Stack } from '@moda/om';
import { formatPrice } from '@moda/portal-stanchions';
import { SiteCredit } from '../../hooks/useSiteCredits/siteCredits.rest';
import { Credit } from './Credit';

import './CreditGroup.scss';

interface Props {
  currency: string;
  credits: SiteCredit[];
}

// Disabled this temporarily, see ECOM-4069.
const SHOW_DETAILS_TOGGLE = false;

export const CreditGroup: React.FC<Props> = ({ currency, credits }) => {
  const [showDetails, setShowDetails] = useState(false);

  const handleClick = useCallback(
    () => SHOW_DETAILS_TOGGLE && setShowDetails(!showDetails),
    [showDetails]
  );
  const totalAmount = credits.reduce((acc, credit) => acc + Number(credit.attributes.amount), 0);
  const formattedTotal = formatPrice(currency, totalAmount);

  return (
    <div
      className="CreditGroup"
      onClick={handleClick}
      onKeyDown={({ key }) => key === 'Enter' && handleClick()}
      role="button"
      tabIndex={0}
    >
      <Stack space={2} className="CreditGroup__preview">
        <span>Remaining Credit ({currency})</span>
        <Stack space={2} justifyContent="space-between" direction="horizontal">
          <span>{formattedTotal}</span>
          {SHOW_DETAILS_TOGGLE && (
            <span className="CreditGroup__show-details-link">
              {showDetails ? 'Hide' : 'See'} Details
            </span>
          )}
        </Stack>
      </Stack>
      {showDetails && (
        <div className="CreditGroup__details">
          {credits.map(({ attributes, id }) => (
            <Credit attributes={attributes} key={id} />
          ))}
          <div className="CreditGroup__total">{formattedTotal}</div>
        </div>
      )}
    </div>
  );
};
